import { render, staticRenderFns } from "./travelSpecsPrice.vue?vue&type=template&id=fc726804&scoped=true&"
import script from "./travelSpecsPrice.vue?vue&type=script&lang=js&"
export * from "./travelSpecsPrice.vue?vue&type=script&lang=js&"
import style0 from "./travelSpecsPrice.vue?vue&type=style&index=0&id=fc726804&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc726804",
  null
  
)

export default component.exports